import { Input } from "@/components/ui/input";
import {
  CellProps,
  isStringControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";
import merge from "lodash/merge";

export const TextCell = (props: CellProps) => {
  const { config, data, id, enabled, uischema, schema, path, handleChange } =
    props;
  const maxLength = schema.maxLength;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);

  return (
    <Input
      type={appliedUiSchemaOptions.format === "password" ? "password" : "text"}
      value={data || ""}
      onChange={(ev) =>
        handleChange(path, ev.target.value === "" ? undefined : ev.target.value)
      }
      id={id}
      disabled={!enabled}
      autoFocus={appliedUiSchemaOptions.focus}
      placeholder={appliedUiSchemaOptions.placeholder}
      maxLength={appliedUiSchemaOptions.restrict ? maxLength : undefined}
      size={appliedUiSchemaOptions.trim ? maxLength : undefined}
    />
  );
};

export const textCellTester: RankedTester = rankWith(2, isStringControl);

export default withJsonFormsCellProps(TextCell);
